<template>
    <div class="card canvas-element">

        <inertia-link :href="show_url">
            <img alt="" class="card-img" :src="preview_url_medium">
        </inertia-link>

        <div class="card-header">
            <inertia-link :href="show_url" class="h5 mb-0 text-decoration-none">{{ element.name }}</inertia-link>
        </div>

        <div class="card-body" v-if="has_any_card_content">

            <template v-if="description">
                <markdown-text :content="description"/>
                <hr v-if="(tenants && tenants.length) || (showGroups && groups && groups.length)">
            </template>

            <div v-if="tenants && tenants.length">
                <span v-for="tenant in tenants" :key="tenant"
                      class="badge badge-primary badge-pill mr-1">{{ tenant }}</span>
            </div>

            <div v-if="showGroups && groups && groups.length">
                <span v-for="group in groups" :key="group"
                      class="badge badge-dark badge-pill mr-1">{{ group }}</span>
            </div>

            <template v-if="showDownload && data?.file?.url">
                <a :href="uploads.url( data?.file?.url )"
                    @click="mixpanel.track('CANVAS_ELEMENT/DOWNLOAD', {element: element.name})"
                   target="_blank"
                   class="btn btn-success">
                    <i class="cvico-download mr-1"></i>
                    Download Activity
                </a>
            </template>

        </div>
        <div class="card-footer" v-if="showEdit && can_edit">
            <inertia-link :href="edit_url" class="btn btn-primary">
                Edit
            </inertia-link>
        </div>
    </div>
</template>

<script>
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import MarkdownText from "@/Components/Common/MarkdownText";

export default {
    name: "CanvasElementCard",
    components: {MarkdownText},
    mixins: [utils, uploads],

    props: {

        element: {
            type: Object,
            default: () => null,
        },

        isPublic: {
            type: Boolean,
            default: false,
        },

        showGroups: {
            type: Boolean,
            default: true,
        },

        showDownload: {
            type: Boolean,
            default: false,
        },

        showEdit: {
            type: Boolean,
            default: true,
        },

        previewPriority: {
            type: String,
            default: 'preview',
        },

    },

    computed: {

        has_any_card_content(){
            return this.description
                || this.has_groups_to_show
                || this.has_tenants
                || this.showDownload;
        },

        has_groups_to_show(){
            return this.showGroups && this.groups && this.groups.length;
        },

        has_tenants(){
            return this.tenants && this.tenants.length;
        },

        can_edit(){
            return this.is_admin || this.element.user_id === this.current_user_id;
        },

        data(){
            return this.element.data;
        },

        type(){
            return this.element.type;
        },

        is_resource(){
            return this.type === 'resource';
        },

        is_activity(){
            return this.type === 'activity';
        },

        resource_type(){
          return this.is_resource ? this.element.data.type : null;
        },


        preview_url_medium(){
            return this.preview_url ? this.uploads.image(this.preview_url, {w: 600, h: 400, c: false}) : 'https://via.placeholder.com/600x400?text=NO+PREVIEW';
        },

        preview_url(){

            switch (this.type){


                case 'activity':

                    if( this.previewPriority === 'preview' ){
                        if( typeof this.data?.preview_file !== 'undefined' ){
                            return (this.data?.preview_file?.preview_url) ? this.data?.preview_file?.preview_url : this.data?.preview_file?.url;
                        }
                    }

                    if( typeof this.data?.file !== 'undefined' ){
                        return (this.data?.file?.preview_url) ? this.data?.file?.preview_url : this.data?.file?.url;
                    }

                    break;


                case 'resource':

                    if( typeof this.data?.file !== 'undefined' ){

                        return (this.data?.file?.preview_url) ? this.data?.file?.preview_url : this.data?.file?.url;
                    }

                    break;

            }

            return null;

        },

        show_url(){
            return this.route('canvas-element.show', {canvas_element: this.element.id, ...this.global_url_params});
        },

        edit_url(){
            return this.route('canvas-element.edit', {canvas_element: this.element.id, ...this.global_url_params});
        },


        description(){
            return this.data?.description;
        },

        groups(){
            return this.element.groups.map(g => `${g.type}:${g.name}`);
        },

        tenants(){
            if(typeof this.element.tenants !== 'undefined'){
                return this.element.tenants.map(t => `${t.name}`);
            }
            return [];
        }

    }

}
</script>

<style lang="scss" scoped>
.card-img{
    width: 100%;
    height: 300px;
    object-fit: cover;
}
</style>
